var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.226562V11.6497H2.39947V5.79001C2.39947 4.81964 2.58933 4.11144 2.96905 3.66201C3.34878 3.21257 3.99038 2.98786 4.90041 2.98786H8.69438V4.84348H5.44054C4.78256 4.84348 4.25226 5.39846 4.25226 6.07942V13.8458L6.47496 11.6497H10.8974V0.226562H0Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlid);
export default __webpack_public_path__ + "static/media/XMLID.92789cad2ae06e65bc052d26c2e5c99b.svg";
export { ForwardRef as ReactComponent };